/**
 * Thrown after a 401 triggers navigation to SSO.
 * Mirrors pod-v0.html's `err.ssoRedirecting = true` so callers can avoid
 * falling through to onboarding while the redirect is in flight.
 */
export class SsoRedirectError extends Error {
  readonly ssoRedirecting = true as const;

  constructor(message = "Session expired — redirecting to login…") {
    super(message);
    this.name = "SsoRedirectError";
  }
}

export function isSsoRedirectError(err: unknown): err is SsoRedirectError {
  return (
    !!err &&
    typeof err === "object" &&
    (err as { ssoRedirecting?: unknown }).ssoRedirecting === true
  );
}
